import defaultAdminFormValidations from 'common/validations/form/defaultAdmin';

const validateEditAdminForm = (values) => {
  const errors = defaultAdminFormValidations(values);

  return errors;
};

export default validateEditAdminForm;
